import React, { Fragment, useEffect, useState, useContext } from 'react'
import { Link, withRouter } from 'react-router-dom'
import styled, {css} from 'styled-components';
import { Context } from '../context';

export function MetadataMore({handle, children}) {
  const context = useContext(Context);
  return (
    <>
      <div className="c_player_commore0"
        onClick={()=> handle()}
      ><div className="x_button x_button--sm">{children}</div></div>
    </>
  )
}